import Axios from "axios";

export const SelectBCFrs = (f,g,a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/BCDVFrs?type=CF&vendeur=${f}&grp=${g}&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "BCF_SELECT", payload: response.data });
    });
  };
};
